import { z } from 'zod';
/**
 * Roadmap público + sugestões de feature.
 *
 * Os usuários votam anonimamente em itens do roadmap (1 voto por par
 * item+browser via hash IP+cookie) e podem sugerir features novas que,
 * se aprovadas pelo admin, viram itens do roadmap.
 */
export const RoadmapStatusSchema = z.enum([
    'considered',
    'planned',
    'in_progress',
    'shipped',
    'rejected',
]);
export const RoadmapCategorySchema = z.enum([
    'ux',
    'ai',
    'integration',
    'performance',
    'billing',
    'other',
]);
export const RoadmapItemSchema = z.object({
    id: z.string().uuid(),
    title: z.string(),
    description: z.string(),
    status: RoadmapStatusSchema,
    category: RoadmapCategorySchema,
    votesCount: z.number().int(),
    createdAt: z.string(),
    shippedAt: z.string().nullable(),
    /** Indica se este browser já votou neste item. */
    hasVoted: z.boolean(),
});
export const RoadmapListResponseSchema = z.object({
    items: z.array(RoadmapItemSchema),
});
export const VoteResponseSchema = z.object({
    itemId: z.string().uuid(),
    votesCount: z.number().int(),
    voted: z.boolean(),
});
export const SubmitSuggestionRequestSchema = z.object({
    name: z.string().trim().max(80).optional(),
    email: z.string().trim().email().max(254).optional().or(z.literal('').transform(() => undefined)),
    content: z
        .string()
        .trim()
        .min(20, 'Conte um pouco mais — mínimo 20 caracteres.')
        .max(2000, 'Resuma — máximo 2000 caracteres.'),
});
export const SubmitSuggestionResponseSchema = z.object({
    id: z.string().uuid(),
    message: z.string(),
});
// ============================================================
// Admin
// ============================================================
export const SuggestionAdminSchema = z.object({
    id: z.string().uuid(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    content: z.string(),
    status: z.enum(['pending', 'approved', 'rejected']),
    adminNote: z.string().nullable(),
    createdAt: z.string(),
    reviewedAt: z.string().nullable(),
    roadmapItemId: z.string().uuid().nullable(),
});
export const ApproveSuggestionRequestSchema = z.object({
    title: z.string().min(8).max(160),
    description: z.string().min(20).max(2000),
    category: RoadmapCategorySchema.default('other'),
    status: RoadmapStatusSchema.default('planned'),
    adminNote: z.string().max(500).optional(),
});
export const RejectSuggestionRequestSchema = z.object({
    adminNote: z.string().max(500).optional(),
});
//# sourceMappingURL=roadmap.js.map